import { Picker } from '@104ha/base-ui';
import { useOptions } from '../hook/use-options';
import type { InputProps, SelectProps } from '@104ha/base-ui';
import { forwardRef } from 'react';

type Props = InputProps & SelectProps;

const CompanySelect = forwardRef((props: Props, ref) => {
	const { companies } = useOptions();

	return (
		<Picker
			ref={ref}
			data={companies}
			dataFilter={(x) => x}
			inactiveIsReadOnly={false}
			behavior="jira"
			{...props}
		></Picker>
	);
});

CompanySelect.displayName = 'CompanySelect';

export { CompanySelect };
